import script from "./DisbursementSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisbursementSummary.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/certification-updates/base.css?vue&type=style&index=0&id=87e591ba&scoped=true&lang=css"
import "@/styles/popovers/base.css?vue&type=style&index=1&id=87e591ba&scoped=true&lang=css"
import "./DisbursementSummary.vue?vue&type=style&index=2&id=87e591ba&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e591ba"]])

export default __exports__